import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { DisposableStore } from '../../../base/common/lifecycle.js';
export var OvertypingCapturer = /*#__PURE__*/function () {
  function OvertypingCapturer(editor, suggestModel) {
    var _this = this;

    _classCallCheck(this, OvertypingCapturer);

    this._disposables = new DisposableStore();
    this._lastOvertyped = [];
    this._empty = true;

    this._disposables.add(editor.onWillType(function () {
      if (!_this._empty) {
        return;
      }

      if (!editor.hasModel()) {
        return;
      }

      var selections = editor.getSelections();
      var selectionsLength = selections.length; // Check if it will overtype any selections

      var willOvertype = false;

      for (var i = 0; i < selectionsLength; i++) {
        if (!selections[i].isEmpty()) {
          willOvertype = true;
          break;
        }
      }

      if (!willOvertype) {
        return;
      }

      _this._lastOvertyped = [];
      var model = editor.getModel();

      for (var _i = 0; _i < selectionsLength; _i++) {
        var selection = selections[_i]; // Check for overtyping capturer restrictions

        if (model.getValueLengthInRange(selection) > OvertypingCapturer._maxSelectionLength) {
          return;
        }

        _this._lastOvertyped[_i] = {
          value: model.getValueInRange(selection),
          multiline: selection.startLineNumber !== selection.endLineNumber
        };
      }

      _this._empty = false;
    }));

    this._disposables.add(suggestModel.onDidCancel(function (e) {
      if (!_this._empty) {
        _this._empty = true;
      }
    }));
  }

  _createClass(OvertypingCapturer, [{
    key: "getLastOvertypedInfo",
    value: function getLastOvertypedInfo(idx) {
      if (!this._empty && idx >= 0 && idx < this._lastOvertyped.length) {
        return this._lastOvertyped[idx];
      }

      return undefined;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._disposables.dispose();
    }
  }]);

  return OvertypingCapturer;
}();
OvertypingCapturer._maxSelectionLength = 51200;